module.exports = __webpack_public_path__ + "img/card_img_1.dec88130.png";